<template>
    <div style="position: relative;">
        <top-bar-secondary>
            <template v-slot:module-action-left>
                <!-- edit mode -->
                <b-navbar-nav v-if="isEditMode">
                    <b-nav-item @click="saveEdit">
                        <div class="center-items">
                            <i class="cus-disk"></i>Save + Done
                        </div>
                    </b-nav-item>
                    <b-nav-item @click="cancelEdit">
                        <div class="center-items">
                            <i class="cus-cancel"></i>Cancel
                        </div>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- saving edit -->
                <b-navbar-nav v-else-if="isSavingEdit">
                    <b-nav-item>
                        <div class="center-items">
                            <i class="cus-hourglass"></i>Saving...
                        </div>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- view mode -->
                <b-navbar-nav v-else>
                    <b-nav-item
                        @click="editReceipt"
                        v-if="
                            _hasAccess('inventory.purchase.order.edit.receipt')
                        "
                    >
                        <div class="center-items">
                            <i class="cus-page-white-edit"></i>Edit Receipt
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        @click="postReceipt"
                        v-if="
                            isStatusOpen &&
                            _hasAccess('inventory.purchase.order.edit.receipt')
                        "
                    >
                        <div class="center-items">
                            <i class="cus-accept"></i>Post Receipt
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        @click="deleteReceipt"
                        v-if="
                            _hasAccess(
                                'inventory.purchase.order.delete.receipt'
                            )
                        "
                    >
                        <div class="center-items">
                            <i class="cus-delete"></i>Delete Receipt
                        </div>
                    </b-nav-item>
                </b-navbar-nav>
            </template>
        </top-bar-secondary>

        <content-wrapper>
            <router-view></router-view>
        </content-wrapper>

        <modal-delete :receiptId="receiptId" ref="modalDelete" />
        <modal-post ref="modalPost" />
    </div>
</template>

<script>
import { DateTime } from "luxon";
import ModalDelete from "@/components/inventory-receipt/modal-delete";
import ModalPost from "@/components/inventory-receipt/modal-post";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";
import ContentWrapper from "@/module/layout/content-wrapper.vue";

export default {
    components: {
        ModalDelete,
        ModalPost,
        TopBarSecondary,
        ContentWrapper
    },
    computed: {
        isStatusOpen() {
            let details = this.$store.state.inventoryReceipt.details;

            if (details && details.status && details.status.id === 0) {
                return true;
            } else {
                return false;
            }
        },
        receiptId() {
            return this.$store.state.inventoryReceipt.receiptId;
        },
        isEditMode() {
            return this.$store.state.inventoryReceipt.isEditMode;
        },
        isSavingEdit() {
            return this.$store.state.inventoryReceipt.isSavingEdit;
        },
        editDetails() {
            return this.$store.state.inventoryReceipt.editDetails;
        },
        items() {
            return this.$store.state.inventoryReceipt.items;
        }
    },
    mounted() {
        this.storeAudit(this.$route.params.id);
    },
    methods: {
        editReceipt() {
            this.$store.commit("inventoryReceipt/initEditOrder");
        },
        async saveEdit() {
            try {
                // handle 'date'. in order to use a function from helpers,
                // we need to do that here, instead in vuex files.
                // vuex - is not a component, so it can't use whatever helper functions (mixin).

                let currentDateValue = this.editDetails.date;
                let dateUnix;

                if (typeof currentDateValue === "string") {
                    dateUnix = DateTime.fromFormat(
                        currentDateValue,
                        this._dateFormat,
                        { zone: this._timeZone }
                    ).toSeconds();
                } else if (typeof currentDateValue === "object") {
                    dateUnix = this._fromDateCarbon(
                        currentDateValue
                    ).toSeconds();
                }

                await this.$store.dispatch("inventoryReceipt/saveEdit", {
                    dateUnix: dateUnix
                });

                this._message("Details have been updated");
            } catch (e) {
                this._message(e.message, "danger");
            }
        },
        cancelEdit() {
            this.$store.commit("inventoryReceipt/cancelEdit");
        },
        deleteReceipt() {
            this.$refs.modalDelete.open();
        },
        postReceipt() {
            let pendingItemNames = [];

            for (let item of this.items) {
                if (!item.post_to) {
                    pendingItemNames.push(item.item_name);
                }
            }

            this.$refs.modalPost.open({
                receiptId: this.receiptId,
                isPending: pendingItemNames.length > 0 ? true : false,
                pendingItems: pendingItemNames
            });
        },
        async storeAudit(receipt) {
            const fullPath = _.clone(this.$router.currentRoute.fullPath);

            if (!receipt) {
                return;
            }

            await this._getSetting();
            await this._saveAudit({
                action: "view",
                path: "/inventory/purchase_order_receipt/view." + receipt,
                reference_id: receipt,
                fullPath
            });
        }
    }
};
</script>

<style scoped>
.center-items {
    display: flex;
    align-items: center;
}
</style>
